/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskPaginatedEagerForm5500Response
 */
export interface ExecRiskPaginatedEagerForm5500Response {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedEagerForm5500Response
     */
    total?: number;
    /**
     * 
     * @type {Array<any>}
     * @memberof ExecRiskPaginatedEagerForm5500Response
     */
    results?: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedEagerForm5500Response
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedEagerForm5500Response
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedEagerForm5500Response
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedEagerForm5500Response interface.
 */
export function instanceOfExecRiskPaginatedEagerForm5500Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskPaginatedEagerForm5500ResponseFromJSON(json: any): ExecRiskPaginatedEagerForm5500Response {
    return ExecRiskPaginatedEagerForm5500ResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedEagerForm5500ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedEagerForm5500Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': !exists(json, 'results') ? undefined : json['results'],
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedEagerForm5500ResponseToJSON(value?: ExecRiskPaginatedEagerForm5500Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': value.results,
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

